import { IGetAllResponse, IGetOneResponse } from '../Utilis/Types/Generic';
import { Note } from '../Utilis/Types/Notes';
import { User } from '../Utilis/Types/User';
import { ApiService } from './ApiService';

export class UserService extends ApiService {
  static pathName = 'user';

  static updateUser = (data: Partial<User>): Promise<IGetOneResponse<User>> => {
    return this.patch(`${this.pathName}/update`, data);
  };

  static uploadDocument = (data: {
    src: string;
    title: string;
    theId: string;
  }): Promise<
    IGetOneResponse<{
      src: string;
      title: string;
      theId: string;
    }>
  > => {
    return this.post(`${this.pathName}/document`, data);
  };

  static deleteDocument = (id: number) => {
    return this.delete(`${this.pathName}/document/${id}`);
  };

  static getNotes = (): Promise<IGetAllResponse<Note>> => {
    return this.get(`${this.pathName}/notes`);
  };

  // Admin

  static getAllUsers = (
    page = 1,
    pageSize = 2,
    type?: string,
    status?: string
  ): Promise<IGetAllResponse<User>> => {
    const newType = type === 'All' ? null : type;
    const newStatus = status === 'All' ? null : status;

    return this.get(
      `${this.pathName}?page=${page}&pageSize=${pageSize}${
        newType ? `&type=${type}` : ''
      }${newStatus ? `&status=${status}` : ''}`
    );
  };

  static getAllMembers = (params: {
    search: string;
    page: number;
  }): Promise<IGetAllResponse<User>> => {
    return this.get('member', undefined, params);
  };

  static createMember = (email: string) => {
    return this.post(`member`, { email });
  };

  static removeMember = (id: string) => {
    return this.delete(`member/${id}`);
  };

  static getOne = (id: string): Promise<IGetOneResponse<User>> => {
    return this.get(`${this.pathName}/${id}`);
  };

  static updateOne = (
    id: string,
    data: Partial<User>
  ): Promise<IGetOneResponse<User>> => {
    return this.patch(`${this.pathName}/update/${id}`, data);
  };

  static searchUser(
    name: string,
    lastName?: string
  ): Promise<IGetAllResponse<User>> {
    return this.get(
      `${this.pathName}/search?name=${name}${
        lastName ? `&lastName=${lastName}` : ''
      }`
    );
  }

  static uploadProfile(file: FormData): Promise<IGetOneResponse<User>> {
    return this.patch(`${this.pathName}/update/profile`, file);
  }
}
